export function CreatedSendersIcon() {
    return (
      <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
      className='neededFill'
        fill="#9197B3"
        d="M14.023 12.144c.209-1.782.275-3.577.2-5.367a.306.306 0 01.088-.23l.75-.75a.151.151 0 01.258.097 35.012 35.012 0 01-.16 6.383 3.347 3.347 0 01-2.952 2.921 36.375 36.375 0 01-8.018 0 3.347 3.347 0 01-2.952-2.921 35.008 35.008 0 010-8.134 3.347 3.347 0 012.952-2.921 36.4 36.4 0 016.09-.163c.132.008.191.166.098.259l-.756.756a.306.306 0 01-.227.09 35.192 35.192 0 00-5.077.194 2.203 2.203 0 00-1.944 1.918 33.864 33.864 0 000 7.868 2.203 2.203 0 001.944 1.918 35.24 35.24 0 007.763 0 2.203 2.203 0 001.943-1.918z"
      ></path>
      <path
      className='neededStroke'
        stroke="#9197B3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.3"
        d="M15 1.777l-6.875 8L5 6.141"
      ></path>
    </svg>
    );
  }